module.exports = __webpack_public_path__ + "static/media/2007.2b068eb0.svg";